import { IconButton, Tooltip } from "@material-ui/core";
import HistoryIcon from "@material-ui/icons/History";
import React from "react";
import { useTranslate } from "react-admin";

import { PalletHistoryDialog } from "./PalletHistoryDialog";

export const PalletHistoryButton = ({ pallet }) => {
	const translate = useTranslate();
	const [open, setOpen] = React.useState(false);

	return (
		<>
			<Tooltip title={translate("osfc.dialogs.pallet_history.title")}>
				<IconButton
					size="small"
					onClick={(e) => {
						e.stopPropagation();
						setOpen(true);
					}}
					style={{ padding: 4 }}
				>
					<HistoryIcon fontSize="small" />
				</IconButton>
			</Tooltip>
			<PalletHistoryDialog
				open={open}
				onClose={() => setOpen(false)}
				pallet={pallet}
			/>
		</>
	);
};
